import React, { PureComponent } from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import { getRequest, postRequest } from "../../api/ApiService";
import CreateGameModal from "../components/create-game-modal";
import { changeLocation } from "api/Location";

bootstrapUtils.addStyle(Button, "light-blue");

const GAMES_LIST_API = `${process.env.REACT_APP_API_URL}games/`;
const COURSES_LIST_API = `${process.env.REACT_APP_API_URL}courses/`;

class GameManagement extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      games: [],
      courses: [],
      games_loaded: false,
      courses_loaded: false,
      createGameModal: false
    };
  }

  componentWillMount() {
    this.fetchCourses();
  }

  fetchGames = () => {
    const { courses } = this.state;
    const ids = courses.map(i => i.id);

    getRequest(GAMES_LIST_API)
      .then(res => {
        this.setState({
          games: res.body.filter(i => ids.includes(i.course)),
          games_loaded: true
        });
      })
      .catch(err => {});
  };

  fetchCourses = () => {
    getRequest(COURSES_LIST_API)
      .then(res => {
        this.setState(
          {
            courses: res.body,
            courses_loaded: true
          },
          () => {
            this.fetchGames();
          }
        );
      })
      .catch(err => {});
  };

  getCourseName = course_id => {
    const { courses } = this.state;
    const course = courses.find(i => i.id === course_id);

    return course ? course.name : "";
  };

  showCreateGameModal = () => {
    this.setState({
      createGameModal: true
    });
  };

  hideCreateGameModal = () => {
    this.setState({
      createGameModal: false
    });
  };

  createGame = (game_name, course_id, number_of_students, callback) => {
    postRequest(GAMES_LIST_API)
      .send({
        name: game_name,
        course: course_id,
        students: number_of_students
      })
      .then(res => {
        callback();
        this.fetchGames();
        this.setState({
          createGameModal: false
        });
      })
      .catch(err => {});
  };

  goToRoundManagement = game_id => {
    changeLocation(`/instructor/round-management/${game_id}`);
  };

  goToTeamManagement = game_id => {
    changeLocation(`/instructor/team-management/${game_id}`);
  };

  render() {
    const {
      games,
      games_loaded,
      courses_loaded,
      createGameModal,
      courses
    } = this.state;

    return (
      <section className="instructorPage">
        <h1>Games</h1>
        <div className="instructorWrapper">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th className="text-center instructor-table-th">No.</th>
                  <th className="text-center instructor-table-th">Game Name</th>
                  <th className="text-center instructor-table-th">
                    Course Name
                  </th>
                  <th className="text-center instructor-table-th">Teams</th>
                  <th className="text-center instructor-table-th">Rounds</th>
                </tr>
              </thead>
              <tbody>
                {(games_loaded === false || courses_loaded === false) && (
                  <tr>
                    <td
                      colSpan={5}
                      className="text-center v-align-middle instructor-td"
                    >
                      Loading...
                    </td>
                  </tr>
                )}
                {games_loaded === true &&
                  courses_loaded === true &&
                  games.map((game, counter) => (
                    <tr key={counter}>
                      <td className="text-center v-align-middle instructor-round-number b-r">
                        {counter + 1}
                      </td>
                      <td className="text-center v-align-middle b-l b-r instructor-td">
                        {game.name}
                      </td>
                      <td className="text-center v-align-middle b-l b-r instructor-td">
                        {this.getCourseName(game.course)}
                      </td>
                      <td className="text-center v-align-middle b-l b-r">
                        <Button
                          bsStyle="light-blue"
                          onClick={() => this.goToTeamManagement(game.id)}
                          block={true}
                        >
                          Manage Teams
                        </Button>
                      </td>
                      <td className="text-center v-align-middle b-l">
                        <Button
                          bsStyle="light-blue"
                          onClick={() => this.goToRoundManagement(game.id)}
                          block={true}
                        >
                          Manage Rounds
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="bottom-button">
            <Button
              bsStyle="light-blue"
              onClick={this.showCreateGameModal}
              block={true}
            >
              Create Game
            </Button>
          </div>
        </div>
        <CreateGameModal
          show={createGameModal}
          onHide={this.hideCreateGameModal}
          courses={courses}
          createGame={this.createGame}
        />
      </section>
    );
  }
}

export default GameManagement;



// WEBPACK FOOTER //
// ./src/instructor/containers/game-management.js